import { render, staticRenderFns } from "./form-branch.vue?vue&type=template&id=c7ab0a42"
import script from "./form-branch.vue?vue&type=script&lang=ts"
export * from "./form-branch.vue?vue&type=script&lang=ts"
import style0 from "./form-branch.vue?vue&type=style&index=0&id=c7ab0a42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports